import { Card, CardContent, Grid, Tabs, Tab, Box } from '@mui/material';
import React, { useState } from 'react';
import TimeTable from './HoursTable';
import InQCTable from './InQCTable';

function TabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`production-tabpanel-${index}`}
      aria-labelledby={`production-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `production-tab-${index}`,
    'aria-controls': `production-tabpanel-${index}`,
  } as const;
}

function ProductionTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      {' '}
      <Card sx={{ margin: '20px 0' }}>
        <CardContent>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="production tabs"
            variant="scrollable"
            allowScrollButtonsMobile
          >
            <Tab label="In Progress" {...a11yProps(0)} />
            <Tab label="In QC" {...a11yProps(1)} />
          </Tabs>

          <TabPanel value={value} index={0}>
            <Grid item xs={12} container>
              <Grid item xs={12} md={12}>
                <TimeTable />
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Grid item xs={12} container>
              <Grid item xs={12} md={12}>
                <InQCTable />
              </Grid>
            </Grid>
          </TabPanel>
        </CardContent>
      </Card>
    </div>
  );
}

export default ProductionTabs;
